import React, { Dispatch, SetStateAction, useMemo } from "react";
import ListView from "@common/components/ListDetailViews/ListView";
import { DeviceModelDetail } from "@services/catalog/types";
import { TabValue } from "@pages/Assets/common/FilterColumn/context";
import { getColumns } from "./colDefs";
import { useSpecificListPreferences } from "@common/components/SpecificPreferences/hooks";
import { attachPreferenceFunctions } from "@common/components/SpecificPreferences/utils";

interface DeviceCatalogListProps {
  onModelClick: (row: DeviceModelDetail) => void | undefined;
  data: DeviceModelDetail[];
  loading: boolean;
  total: number;
  pageSize: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  sort: Sort<DeviceModelDetail>;
  setSort: Dispatch<SetStateAction<Sort<DeviceModelDetail>>>;
}

export const DeviceCatalogList = (props: DeviceCatalogListProps) => {
  const {
    onModelClick,
    data,
    total,
    pageSize,
    page,
    setPage,
    sort,
    setSort,
    loading,
  } = props;

  const [
    { columnOrder, columnWidths },
    setSpecificListPreferences,
    { updateWidth },
  ] = useSpecificListPreferences();

  const columns = useMemo(() => {
    const columns = getColumns(onModelClick).filter((x) =>
      x.tab?.includes(TabValue.Info)
    );

    return attachPreferenceFunctions(columns)
      .applyColumnSizes(columnWidths)
      .sortColumnOrder(columnOrder);
  }, [columnOrder, columnWidths]);

  return (
    <ListView
      data={data ?? []}
      columns={columns}
      onColumnsOrderChange={(order) =>
        setSpecificListPreferences({ columnOrder: order.map((c) => c.key) })
      }
      rememberScrollTop
      onColumnWidthChange={updateWidth}
      loading={loading}
      total={total}
      pageSize={pageSize}
      page={page}
      setPage={setPage}
      identityKey="id"
      sort={sort}
      pinFirstColumn
      onSort={(column, direction) => setSort({ column, direction })}
    />
  );
};
